import { getGapi } from "./index";
import { MimeTypes } from "./types/MimeTypes";

const URL = "https://www.googleapis.com/drive/v3/files";

const getRequestInit = (): RequestInit => {
  const gapi = getGapi();
  const { access_token: accessToken } = gapi.auth.getToken();

  return ({ headers: { Authorization: `Bearer ${accessToken}` } });
};

const downloadFile = (fileId: string) => (
  fetch(`${URL}/${fileId}?alt=media`, getRequestInit()).then(res => res.blob())
);

const exportType = "application/pdf";

const exportFile = (fileId: string) => (
  fetch(`${URL}/${fileId}/export?mimeType=${exportType}`, getRequestInit()).then(res => res.blob())
);

const throwError = (fileId: string) => Promise.reject(`File with ${fileId} could not be uploaded or exported.`);

const getBlob = {
  [MimeTypes.epub]: downloadFile,
  [MimeTypes.doc]: downloadFile,
  [MimeTypes.pdf]: downloadFile,
  [MimeTypes.gDoc]: exportFile,
  [MimeTypes.gFolder]: throwError,
  [MimeTypes.docx]: downloadFile,
  [MimeTypes.txt]: downloadFile,
};

interface GetFileResponse {
  result: {
    name: string;
    mimeType: MimeTypes;
    modifiedTime: string;
  };
}

const fields = "name, mimeType, modifiedTime";

export const getFile = async (fileId: string) => {
  const gapi = getGapi();
  const { result: { name, mimeType, modifiedTime } } = await gapi.client.drive.files.get({ fileId, fields }) as GetFileResponse;
  const blob = await getBlob[mimeType](fileId);
  const options: FilePropertyBag = {
    type: mimeType === MimeTypes.gDoc ? exportType : mimeType,
    lastModified: new Date(modifiedTime).getTime(),
  };

  return new File([blob], name, options);
};
